"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _classnames = _interopRequireDefault(require("classnames"));

var _AiStarsV2Gradient = _interopRequireDefault(require("@insided/destination/icons/AiStarsV2Gradient"));

var Loading = function Loading() {
  return (0, _preact.h)("div", {
    className: (0, _classnames.default)('loader row')
  }, (0, _preact.h)("div", {
    className: "ai-logo"
  }, (0, _preact.h)(_AiStarsV2Gradient.default, null)), (0, _preact.h)("div", {
    className: "content"
  }, (0, _preact.h)("div", {
    className: "generating-text"
  }, (0, _preact.h)(_phrase.default, {
    p: "search.smart.summary.generating"
  }), (0, _preact.h)("div", {
    className: "skeleton"
  }, (0, _preact.h)("div", {
    className: (0, _classnames.default)('line line-1')
  }), (0, _preact.h)("div", {
    className: (0, _classnames.default)('line line-2')
  })))));
};

var _default = Loading;
exports.default = _default;